/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FireboardUtils from '../../../../../util/fireboard-util';
import classes from './TileContent.module.css';

const TileContent = ({ check }) => {
  const { deliverTo, orders } = check || {};
  const [order0] = orders || [];
  const { pickupDate } = order0 || {};
  const pickupTime = pickupDate ? FireboardUtils.getTimeInHrsMins(pickupDate) : '';

  return (
    <div className={classes.contentWrapper}>
      <div className={classNames({ [classes.value]: true, [classes.wrappedContent]: true })}>
        {deliverTo}
      </div>
      <div className={classNames({ [classes.value]: true, [classes.wrappedContent]: true })}>
        {pickupTime}
      </div>
    </div>
  );
};

export default TileContent;

TileContent.propTypes = {
  check: PropTypes.object,
};

TileContent.defaultProps = {
  check: {},
};
